import { render, staticRenderFns } from "./addActivity.vue?vue&type=template&id=b5346f86&"
import script from "./addActivity.vue?vue&type=script&lang=js&"
export * from "./addActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports